import { createUseStyles } from 'react-jss'

export default createUseStyles({
  fileContainer: {
    marginTop: 10
  }
})
